module.exports = __webpack_public_path__ + "static/media/activation_code_front.d50d8209.png";